import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';

export const ContactInfoWrapper = styled(Flex)<{ $isCompact?: boolean }>`
  margin-bottom: ${({ theme }) => theme.space[6]};
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: ${({ $isCompact }) => ($isCompact ? '4px 8px' : '4px 16px')};
  /* Remove margin when in stacked layout at 1440px */
  @media (max-width: 90rem) {
    margin-bottom: 0;
  }
  ${({ theme }) => css`
    @media (max-width: ${theme.components.footer.breakpoint}) {
      margin-top: ${theme.space.s200};
    }
  `}
`;

export const PointerWrapper = styled(Box)`
  cursor: pointer;
`;
